import './form.scss'
const $ = window.jQuery

class Form {
  constructor(settings) {
    this.settings = settings
    this.t = {}
    this.domain = this.getCurrentDomainName()
    this.userAgent = window.navigator.userAgent
  }

  init() {
    const lang = (this.settings.lang.indexOf(this.settings.userLang) > -1)
      ? this.settings.userLang : this.settings.lang[0]
    const langFile = `${this.settings.cdnUrl}qcf_${lang}.json`

    fetch(langFile)
      .then((response) => response.json())
      .then((json) => {
        this.settings.fields = json.fields
        this.t = json.translations
        this.loadForm()
        this.loadCaptcha()
        this.bindEvents()
      })
  }

  getCurrentDomainName() {
    const domain = window.location.hostname
    const parts = domain.split('.')
    return (parts.length > 2) ? domain.replace(/^[^.]+\./g, '') : domain
  }

  loadForm() {
    if (this.domain !== 'localhost') {
      const style = document.createElement('link')
      style.rel = 'stylesheet'
      style.href = `${this.settings.cdnUrl}qcf.css`
      document.getElementsByTagName('head')[0].appendChild(style)
    }

    const form = this.generateForm()
    const content = document.getElementById(this.settings.selector)
    content.innerHTML += form
  }

  loadCaptcha() {
    const captcha = document.createElement('script')
    captcha.src = 'https://www.google.com/recaptcha/api.js'
    captcha.async = 'async'
    captcha.defer = 'defer'
    document.getElementsByTagName('body')[0].appendChild(captcha)
  }

  verifyCaptcha() {
    const response = window.grecaptcha.getResponse()
    return response
  }

  generateForm() {
    const tmpl = `
      <form id="qcf__form" data-toggle="validator" role="form">
        <input type="hidden" name="Source" value="${this.domain}">
        <input type="hidden" name="URL" value="${window.location.href}">
        ${this.settings.fields.map((field) =>
          this.generateFormElement(field)
        ).join('')}
        <div id="qcf__message"></div>
      </form>
    `
    return tmpl
  }

  generateFormElement(data) {
    let elmt = `<div
      class="form-group"
      id="_${data.name}"
      ${(data.hidden) ? 'style="display: none;"' : ''}
    >`

    switch (data.type) {
      case 'text':
      case 'tel':
      case 'email':
      case 'number':
        elmt += `
          <label for="${data.name}">${data.label}</label>
          ${(data.required) ? '<span style="color: red;">*</span>' : ''}
          <input
            type="text"
            name="${data.name}"
            id="${data.name}"
            class="form-control"
            ${(data.placeholder) ? `placeholder="${data.placeholder}"` : ''}
            ${(data.value) ? `value="${data.value}"` : ''}
            ${(data.pattern) ? `pattern="${data.pattern}"` : ''}
            ${(data.required) ? 'required' : ''}
          >
        `
        break
      case 'radio':
        elmt += `
          <div class="radio">
            ${(data.label) ? `<strong>${data.label}</strong>:` : ''}
            ${(data.required) ? '<span style="color: red;">*</span>' : ''}
            ${data.values.map((radio) => `
              <label>
                <input
                  type="radio"
                  name="${data.name}"
                  value="${radio.value}"
                  ${(radio.checked) ? 'checked' : ''}
                >
                ${radio.name}
              </label>
            `).join('')}
          </div>
        `
        break
      case 'select':
        elmt += `
          <label for="${data.name}">${data.label}</label>
          ${(data.required) ? '<span style="color: red;">*</span>' : ''}
          <select
            class="form-control"
            name="${data.name}"
            id="${data.name}"
            ${(data.required) ? 'required' : ''}
          >
            ${data.options.map((option) => `
              <option
                value="${option.value}"
                ${(option.group) ? `data-group="${option.group}"` : ''}
              >${option.name}</option>
            `).join('')}
          </select>
        `
        break
      case 'textarea':
        elmt += `
          <label for="${data.name}">${data.label}</label>
          ${(data.required) ? '<span style="color: red;">*</span>' : ''}
          <textarea
            name="${data.name}"
            cols="55"
            rows="5"
            class="form-control"
            id="${data.name}"
            ${(data.required) ? 'required' : ''}
          ></textarea>
        `
        break
      case 'captcha':
        elmt += `
          <div
            class="g-recaptcha"
            data-sitekey="${data.sitekey}"
            data-callback="verifyCallback"
          ></div>
        `
        break
      case 'button':
        elmt += `
          <button type="submit" class="btn btn-primary">
            ${data.label}
          </button>
        `
        break
      default:

    }

    return `${elmt}</div>`
  }

  bindEvents() {
    this.displayObjects(1)

    $(document)
      .on('submit', '#qcf__form', (e) => {
        e.preventDefault()
        if (this.verifyCaptcha()) {
          this.sendToWs($(e.currentTarget).serialize())
        } else {
          this.displayMessage(this.t.wrong_captcha, 'error')
        }
      })
      .on('change', 'input[name="ProHo"]', (e) => {
        const value = $(e.currentTarget).val()
        if (value === 'HO') {
          $('#_IsCustomer').hide()
          $('#_CompanyName').hide()
          $('#_ContractRef').hide()
          $('#_Salutation').show()
          $('#_LeadRefNumber').show()
          $('#CompanyName').removeAttr('required')
          $('#MobilePhone').removeAttr('required')
          $('#_MobilePhone').find('span').text('')
          this.displayObjects(3)
        } else if (value === 'Pro') {
          $('#_IsCustomer').show()
          $('#_CompanyName').show()
          $('#_Salutation').hide()
          $('#_LeadRefNumber').hide()
          $('#CompanyName').attr('required', true)
          $('#MobilePhone').attr('required', true)
          $('#_MobilePhone').find('span').text('*')
          if ($('input[name="IsCustomer"]').val() === 'Yes') {
            $('#_ContractRef').show()
          }
          this.displayObjects(1)
        }
      })
      .on('change', 'input[name="IsCustomer"]', (e) => {
        const value = $(e.currentTarget).val()
        if (value === 'No') {
          $('#_ContractRef').hide()
          this.displayObjects(1)
        } else if (value === 'Yes') {
          $('#_ContractRef').show()
          this.displayObjects(2)
        }
      })
  }

  displayObjects(group) {
    $('#Subject option').each((i, el) => {
      const opt = $(el)
      const parent = opt.parent()

      if (opt.data('group') === group) {
        if (parent.get(0).tagName === 'SPAN') {
          parent.replaceWith(opt.get(0))
        }
        opt.get(0).disabled = false
        opt.show()
      } else {
        if (parent.get(0).tagName === 'SPAN') {
          parent.hide()
        } else {
          if (this.userAgent.indexOf('MSIE ') > 0 || !!this.userAgent.match(/Trident.*rv:11\./)) {
            opt.wrap('<span></span>').hide()
          } else {
            opt.hide()
          }
        }
        opt.get(0).disabled = true
      }
    })
    $('#Subject').val($('#Subject option:visible').val())
  }

  sendToWs(values) {
    $.ajax({
      url: this.settings.wsUrl,
      data: values,
      dataType: 'jsonp',
      success: (response) => {
        if ('error' in response) {
          this.displayMessage(this.t.error_occurred, 'error')
        } else {
          this.displayMessage(this.t.success_send, 'success')
        }
      },
      error: () => {
        this.displayMessage(this.t.error_occurred, 'error')
      }
    })
  }

  displayMessage(text, type) {
    $(document).find('#qcf__message')
      .hide()
      .removeClass('error')
      .removeClass('success')
      .addClass(type)
      .text(text)
      .slideDown()
  }
}

export default Form



/** WEBPACK FOOTER **
 ** ./src/components/Form/index.js
 **/